import CardsGrid from "./CardsGrid";

const CardsGridWithProps = ({ blok }) => {
  return <CardsGrid sectionTitle={blok.sectionTitle} cards={blok.cards} theme={blok.theme} />;
};

export default CardsGridWithProps;
